import {
	GetAnswerSheetActionsTypes, 
	GetAnswerSheetsActionsTypes,
	GetAnswerSheetsByAssessmentActionsTypes,
	CreateAnswerSheetActionsTypes, 
	UpdateAnswerSheetActionsTypes, 
	DeleteAnswerSheetActionsTypes,
	IAnswerSheetsState,
	AnswerSheetActions,
} from './types';

const initialState: IAnswerSheetsState = {
	answerSheets: [],
	selectedAnswerSheet: null,
	selectedId: -1,
	loading: false,
	error: '',
	success: false,
	create: {
		loading: false,
		error: '',
		success: false,
	},
	update: {
		loading: false,
		error: '',
		success: false,
	},
	delete: {
		loading: false,
		error: '',
		success: false,
	}
};

const answerSheetsReducer = (state: IAnswerSheetsState = initialState, action: AnswerSheetActions) => {
	switch (action.type) {
		
		// ----------------------Get Answer Sheet Actions-----------------------
		case GetAnswerSheetActionsTypes.GET_ANSWER_SHEET: {
			return {
				...state,
				loading: true,
				error: '',
			};
		}
		case GetAnswerSheetActionsTypes.GET_ANSWER_SHEET_SUCCESS: {
			const { loading, data } = action;
			return {
				...state,
				selectedAnswerSheet: data.data,
				selectedId: data.data.id,
				loading,
				success: true,
				error: '',
			};
		}
		case GetAnswerSheetActionsTypes.GET_ANSWER_SHEET_ERROR: {
			const { error } = action;
			return {
				...state,
				loading: false,
				success: false,
				error: error,
			};
		}

		// ----------------------Get Answer Sheets Actions-----------------------
		case GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS: {
			return {
				...state,
				loading: true,
				error: '',
			};
		}
		case GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS_SUCCESS: {
			const { loading, data } = action;
			return {
				...state,
				loading,
				success: true,
				error: '',
				answerSheets: data.data?.answerSheets || [],
				// Reset action states after list refresh
				create: { success: false, loading: false, error: '' },
				update: { success: false, loading: false, error: '' },
				delete: { success: false, loading: false, error: '' },
			};
		}
		case GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS_ERROR: {
			const { error } = action;
			return {
				...state,
				loading: false,
				success: false,
				error: error,
			};
		}

		// ----------------------Get Answer Sheets By Assessment Actions-----------------------
		case GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT: {
			return {
				...state,
				loading: true,
				error: '',
			};
		}
		case GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT_SUCCESS: {
			const { loading, data } = action;
			return {
				...state,
				loading,
				success: true,
				error: '',
				answerSheets: data.data?.answerSheets || [],
				// Reset action states after list refresh
				create: { success: false, loading: false, error: '' },
				update: { success: false, loading: false, error: '' },
				delete: { success: false, loading: false, error: '' },
			};
		}
		case GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT_ERROR: {
			const { error } = action;
			return {
				...state,
				loading: false,
				success: false,
				error: error,
			};
		}

		// ----------------------Create Answer Sheet Actions-----------------------
		case CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET: {
			return {
				...state,
				create: { loading: true, success: false, error: '' },
			};
		}
		case CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET_SUCCESS: {
			return {
				...state,
				create: { success: true, loading: false, error: '' },
			};
		}
		case CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET_ERROR: {
			const { error } = action;
			return {
				...state,
				create: { success: false, loading: false, error: error || 'Failed to create answer sheet' },
			};
		}

		// ----------------------Update Answer Sheet Actions-----------------------
		case UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET: {
			return {
				...state,
				update: { loading: true, success: false, error: '' },
			};
		}
		case UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET_SUCCESS: {
			return {
				...state,
				update: { success: true, loading: false, error: '' },
			};
		}
		case UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET_ERROR: {
			const { error } = action;
			return {
				...state,
				update: { success: false, loading: false, error: error || 'Failed to update answer sheet' },
			};
		}

		// ----------------------Delete Answer Sheet Actions-----------------------
		case DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET: {
			return {
				...state,
				delete: { loading: true, success: false, error: '' },
			};
		}
		case DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET_SUCCESS: {
			return {
				...state,
				delete: { success: true, loading: false, error: '' },
			};
		}
		case DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET_ERROR: {
			const { error } = action;
			return {
				...state,
				delete: { success: false, loading: false, error: error || 'Failed to delete answer sheet' },
			};
		}

		default:
			return state;
	}
};

export default answerSheetsReducer;
